export default {"src":"/_next/static/media/tn.d2b7f846.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};